import { ListSystemsIssuesResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { aqoraClient } from '~/services/api/aqora-client';
import { SYSTEMS_PAGE_SIZE } from '~/services/api/fetchers/system.api';

export const listSystemsIssues = async (): Promise<ListSystemsIssuesResponse> =>
  await aqoraClient.listSystemsIssues({
    pageSize: SYSTEMS_PAGE_SIZE,
  });
